import { loggerService } from '@brainpool/logger';

export function parseAdvisorJsonContent(content: string): any | null {
  const match = content.match(/```json\s*([\s\S]*?)```/);
  let jsonString: string;
  if (match) {
    jsonString = match[1].trim();
    // If wrapped in quotes, unescape
    if (jsonString.startsWith('"') && jsonString.endsWith('"')) {
      jsonString = jsonString
        .slice(1, -1)
        .replace(/\\"/g, '"')
        .replace(/\\\\n/g, '\\n')
        .replace(/\\n/g, '\n');
    }
    try {
      return JSON.parse(jsonString);
    } catch {
      return null;
    }
  } else {
    // Fallback: try to parse the raw string as JSON
    try {
      return JSON.parse(content);
    } catch {
      return content;
    }
  }
}
export function escapeNewlinesInJsonString(jsonStr: string): string {
  try {
    const obj = JSON.parse(jsonStr);
    // JSON.stringify will escape newlines and other special characters as needed
    return JSON.stringify(obj);
  } catch {
    // If parsing fails, return the original string
    return jsonStr;
  }
}
export function extractUserMessage(content: string): string | undefined {
  try {
    const trimmed = content.trim();
    const escaped = escapeNewlinesInJsonString(trimmed);
    try {
      const parsed = JSON.parse(escaped);
      if (typeof parsed.message === 'string') {
        return parsed.message;
      }
    } catch {
      // Fallback: extract "message" value with regex if JSON.parse fails
      const match = escaped.match(/"message"\s*:\s*"([^"]*)"/);
      if (match && match[1]) {
        return match[1];
      }
    }
    // If content isn't JSON-wrapped (or doesn't contain "message"), treat it as plain text.
    if (trimmed.length > 0) {
      return trimmed;
    }
  } catch (e) {
    loggerService.log({
      logLevel: 'error',
      message: 'Failed to extract user message',
      context: {
        error: e,
        content,
      },
    });
  }
  return undefined;
}
